import {
    Checkbox,
    TableCell, TableRow
} from "@material-ui/core";
import React, {useEffect, useState} from "react";


const ValidatedAddressRow = ({address, selectedAddress, handleSelectOne, index,selectedAddressIndex, key,...props}) => {
    const [isChecked, setIsChecked] = useState(selectedAddressIndex === index);
    useEffect(() => {
        setIsChecked(selectedAddressIndex === index);
    }, [selectedAddressIndex, index]);

    const street = [
        address?.primary_number || "",
        address?.street_predirection || "",
        address?.street_name || "",
        address?.street_suffix || "",
        address?.street_postdirection || "",
    ].filter(Boolean).join(" ");
    const secondary = [
        address?.secondary_designator || "",
        address?.secondary_number || "",
        address?.extra_secondary_designator || "",
        address?.extra_secondary_number || "",
    ].filter(Boolean).join(" ");

    return (
        <TableRow hover key={key}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isChecked}
                    color="primary"
                    onChange={() => handleSelectOne(index)}
                />
            </TableCell>
            <TableCell>{street}</TableCell>
            <TableCell>{secondary}</TableCell>
            <TableCell>{address.city_name}</TableCell>
            <TableCell>{address.state_abbreviation}</TableCell>
            <TableCell>{address.full_zipcode}</TableCell>
            <TableCell>{address.summary}</TableCell>
        </TableRow>
    )
}

export default ValidatedAddressRow;